/* eslint-disable react/no-danger */
import { useSelector } from 'react-redux'

import NoDescriptionMessage from './NoDescriptionMessage'

const DescriptionContent = () => {
  const description = useSelector(
    state => state.asset.productDetails.description
  )

  return (
    <Choose>
      <When condition={description}>
        <div
          className='description'
        >
          <div
            className='pdp-description line-height-3'
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </When>
      <Otherwise>
        <NoDescriptionMessage />
      </Otherwise>
    </Choose>
  )
}

export default DescriptionContent
